<template>
  <Card class="page-patientConfig">
    <div class="quest-titles" style="text-align: right; margin-bottom: 15px">
      <el-button
        type="primary"
        round
        class="creatBtn"
        @click="addGroup2"
        style="background: #4286f1;"
      >新增分组</el-button>
    </div>

    <Table :columns="columns" :data="list" :loading="loading">
      <template slot-scope="{row}" slot="name">
        <template>{{row.name}}</template>
      </template>
      <template slot-scope="{row}" slot="sort">
        <template>{{row.sort}}</template>
      </template>
      <template slot-scope="{row}" slot="permissions">
        <template>{{row.permissions == 'team' ? '团队可见' : '个人可见'}}</template>
      </template>
      <template slot-scope="{row}" slot="create_time">
        <template>{{row.create_time}}</template>
      </template>
      <template slot-scope="{row}" slot="update_time">
        <template>{{row.update_time}}</template>
      </template>

      <template slot-scope="{row, index}" slot="action">
        <caring-button @click="edit(row, index)">编辑</caring-button>
        <caring-button @click="del(row, index)">删除</caring-button>
      </template>
    </Table>
    <div style="margin-top:16px;text-align:right;">
      <Page
        :total="total"
        :current="current"
        :page-size="size"
        :page-size-opts="sizes"
        :show-total="true"
        :show-elevator="true"
        :show-sizer="true"
        @on-change="onCurrentChange"
        @on-page-size-change="onSizeChange"
      />
    </div>
  </Card>
</template>
<script>
import { getGroup, deleteGroupApi } from '../../api/group'
import { Message, MessageBox } from 'element-ui'
import route from '../../route/config'

export default {
  data() {
    return {
      total: 0,
      current: 1,
      size: 10,
      sizes: [5, 10, 30, 40],
      columns: [
        {
          title: '分组名称',
          slot: 'name',
          align: 'center',
        },
        {
          title: '排序',
          slot: 'sort',
          align: 'center',
          width: '150px',
        },
        {
          title: '权限',
          slot: 'permissions',
          align: 'center',
        },
        {
          title: '创建时间',
          slot: 'create_time',
          align: 'center',
        },
        {
          title: '更新时间',
          slot: 'update_time',
          align: 'center',
        },
        {
          title: '操作',
          slot: 'action',
          width: 200,
          align: 'center',
        },
      ],
      list: [],
      loading: true,
      title: '新增标签',
      oktext: '确定',
      value: '',
      curModule: {
        name: '',
      },
      moduleRule: {
        name: [
          {
            required: true,
            message: '请填写标签名称',
            trigger: 'blur',
          },
        ],
      },
      id: '',
      type: '1', //0：筛选 1：慢病
    }
  },

  created() {
    this.getGroupList()
  },
  mounted() {},
  methods: {
    getGroupList: function () {
      let type = this.type
      let page = this.current
      let size = this.size
      let need_page = 1
      getGroup({ type, page, size, need_page }).then((res) => {
        this.loading = false
        if (res.code === 0) {
          // console.log(res)
          let list = res.data
          this.list = list
          this.total = Number(res['x-total-count'])
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    onCurrentChange: function (current) {
      this.current = current
      this.getGroupList()
    },
    onSizeChange: function (size) {
      this.size = size
      this.getGroupList()
    },
    addGroup2: function () {
      console.log('新增筛查', this.type)
      this.$store.commit('setAllSelectedKeys', {
        type: 'add',
        name: 'addGroup2',
        title: route['addGroup2'].title,
        key: `addGroup2`,
        extra: {
          type: this.type,
        },
      })
    },
    edit: function (row, index) {
      let info = JSON.parse(JSON.stringify(row))
      console.log(row)
      this.$store.commit('setAllSelectedKeys', {
        type: 'add',
        name: 'addGroup2',
        title: '编辑分组',
        key: `addGroup2?${info.id}`,
        extra: {
          info: info,
          type: this.type,
        },
      })
    },
    del: function (row) {
      MessageBox.confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      }).then(() => {
        deleteGroupApi(row.id).then((res) => {
          if (res.code === 0) {
            // console.log(res)
            this.$Message.success('删除成功')
            const totalPage = Math.ceil((this.total - 1) / this.size) // 总页数
            this.current = this.current > totalPage ? totalPage : this.current
            this.current = this.current < 1 ? 1 : this.current
            this.getGroupList()
          } else {
            this.$Message.error(res.message)
          }
        })
      })
    },
    cancelModule: function () {
      this.modalShow = false
    },
    saveModule: function (formName) {
      console.log(this.curModule)
      let name = this.curModule.name
      let type = this.type

      let obj = {
        name: name,
        type: type,
      }
      if (!this.isAdd) {
        obj = {
          id: this.id,
          name: name,
          type: type,
        }
      }

      this.$refs[formName].validate((valid) => {
        if (valid) {
          addTag(obj).then((res) => {
            if (res.code === 0) {
              // console.log(res)
              this.$Message.success('新增成功')
              this.modalShow = !this.modalShow
              this.getTagList()
            } else {
              this.$Message.error(res.message)
            }
          })
        } else {
          return false
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
</style>
